import { formatDateTimeCompact } from "@/helpers/date";
import { Funcion } from "@/types";
import { parseFuncionDate } from "../../utils/dateUtils";

type ListadoFuncionesProps = {
    funciones: Funcion[];
    onSeleccion: (funcion: Funcion) => void;
    funcionSeleccionada: Funcion | null;
}
export const ListadoFunciones = ({ funciones, onSeleccion, funcionSeleccionada }: ListadoFuncionesProps) => {

    const setClassName = (activa: boolean, agotado: boolean) => {
        let className =
            "w-full flex items-center justify-center border rounded-full px-3 py-2 " +
            "transition-all text-xs sm:text-sm relative";

        if (agotado) {
            className += " opacity-50 cursor-not-allowed border-red-400 text-red-300";
        } else {
            className += " text-white cursor-pointer";
            className += activa
                ? " shadow-primary-900/50 shadow-md border-primary-400/60 bg-primary-900/40"
                : " hover:shadow-primary-900/50 hover:shadow-md hover:border-primary-400/40 bg-transparent";
        }

        return className;
    };

    return (
        <ul className="flex w-full gap-3 flex-wrap">
            {funciones.map((f) => {

                const { day, dayOfWeek, month, timePuertas, timeShow } = parseFuncionDate(f.fecha, f.hora)

                return (
                    <li
                        key={f.id}
                        className="flex-1 min-w-[90px] max-w-[150px]"
                    >
                        <button
                            className={setClassName(f.id === funcionSeleccionada?.id, f.status === 'agotado')}
                            onClick={() => f.status !== 'agotado' && onSeleccion(f)}
                            disabled={f.status === 'agotado'}
                        >
                            <div className="flex flex-col items-center leading-tight w-full">
                                <p className="text-[0.7rem] opacity-80">
                                    {`${dayOfWeek} ${day} ${month.slice(0, 3)} · ${timeShow}`}
                                </p>
                                {f.status === 'agotado' && (
                                    <span className="text-[0.6rem] font-bold mt-0.5 text-red-400">AGOTADO</span>
                                )}
                            </div>
                        </button>
                    </li>
                )
            }
            )}
        </ul>
    );
};
